import React, { useState } from "react";
import PropTypes from "prop-types";
import { SlideDown } from "react-slidedown";
import { usePadding } from "@/components/utils/Padding";
import "react-slidedown/lib/slidedown.css";
import "./styles.scss";

/* #META
 {
  "NAME": "Comparative",
  "CLASSNAME": "comparative-component",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const Comparative = ({ data }) => {
  const comparativeModule = data?.comparative_module;
  if (!comparativeModule) return null;

  const { padding_component, comparative_cards, show_open_cards, title_color } = comparativeModule;
  const [openCards, setOpenCards] = useState(() => {
    const isOpen = show_open_cards;
    const initialState = {};
    comparative_cards?.forEach((_, index) => {
      initialState[index] = isOpen;
    });
    return initialState;
  });

  const paddingStyle = usePadding(padding_component);

  const toggleCard = (index) => {
    setOpenCards((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div className="comparative-component" style={paddingStyle}>
      <div className="container-revamp">
        <div className="comparative-cards-container">
          {comparative_cards?.map((card, index) => (
            <div key={index} className="comparative-card">
              <div className="comparative-card-header">
                <h4 className={`card-title--${title_color}`}>{card?.card_title}</h4>
                <button onClick={() => toggleCard(index)}>
                  {openCards[index] ? "" : ""}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="43"
                    height="42"
                    viewBox="0 0 43 42"
                    fill="none"
                    className={`
                      transition-transform duration-300
                      ${openCards[index] ? "rotate-180" : "rotate-0"}
                    `}
                  >
                    <path
                      d="M11 15.75L21.5 26.25L32 15.75"
                      stroke="#FDE5AC"
                      strokeWidth="4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <SlideDown>
                {openCards[index] && (
                  <div
                    className="comparative-card-content"
                    dangerouslySetInnerHTML={{ __html: card?.card_content }}
                  />
                )}
              </SlideDown>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

Comparative.propTypes = {
  data: PropTypes.shape({
    acf_fc_layout: PropTypes.string,
    comparative_module: PropTypes.shape({
      show_open_cards: PropTypes.bool,
      comparative_cards: PropTypes.arrayOf(
        PropTypes.shape({
          card_title: PropTypes.string,
          card_content: PropTypes.string,
        })
      ),
    }),
  }),
};

export default Comparative;
